import { render } from "./SetupTwoFaAtLogin.vue?vue&type=template&id=282bd667&scoped=true"
import script from "./SetupTwoFaAtLogin.vue?vue&type=script&lang=js"
export * from "./SetupTwoFaAtLogin.vue?vue&type=script&lang=js"

import "./SetupTwoFaAtLogin.vue?vue&type=style&index=0&id=282bd667&scoped=true&lang=css"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-282bd667"]])

export default __exports__